<template>
  <div class="wrap">
    <div v-if="config && config.status == 0">
      <noPage />
    </div>
    <template v-else>
      <Header />
      <div class="layout-wrap" ref="layout">
        <router-view />
      </div>
      <Footer />
      <el-dialog
        :visible.sync="dialogVisible"
        width="500"
        :before-close="handleClose"
      >
        <div class="block_wrap" v-if="config.block && config.block.length" :style="{ borderBottom: config.closed_time.length != 0 ? '1px dashed rgb(69, 69, 69)': ''}">
          <div class="dialog_title">
            BLOCK DAY NOTICE
          </div>
          <div>
            We are CLOSED for Public holiday during the following times:
          </div>
          <div
            v-for="(item, index) in config.block"
            :key="index"
            class="time"
          >
            {{ item.block_date }} 
            <!-- {{ item.remark }} -->
          </div>
        </div>
        <div v-if="config.closed_time && config.closed_time.length">
          <div class="dialog_title">
            SPECIAL HOURS NOTICE
          </div>
          <div>
            We are CLOSED for private events during the following times:
          </div>
          <div
            v-for="(item, index) in config.closed_time"
            :key="index"
            class="time"
          >
            {{ item.date }} {{ item.start_time }} - {{ item.end_time }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button @click="dialogVisible = false"
            >OK</el-button
          >
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import store from "@/store";
import noPage from "../pages/pageDisable.vue";
export default {
  name: "Layout",
  components: {
    Header,
    Footer,
    noPage,
  },
  data() {
    return {
      hHeight: 0,
      show: false,
      dialogVisible: false
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  watch: {
    config(val) {
      if(val.closed_time.length || val.block.length) {
        this.dialogVisible = true
      }
    }
  },
  mounted() {
    store.dispatch("global/fetchConfigList", {});
    store.dispatch("global/fetchHeaderTabs", {});
    store.dispatch("global/fetchFooterTabs", {});
    store.dispatch("global/fetchShopList", {});
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    }
  }
};
</script>
<style scoped>
.layout-wrap {
  position: relative;
  z-index: 1;
}
.backup {
  width: 100%;
  position: absolute;
  top: 0px;
  z-index: -1;
}
.backdown {
  width: 100%;
  position: absolute;
  bottom: 0px;
  z-index: -1;
}
.content-wrap {
  min-height: 1200px;
}

.time {
  padding: 10px;
}

.block_wrap {
  padding-bottom: 10px;
}
.dialog_title {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue